/**
 * Ethereum chain configurations
 */

const config = {
  /**
   * Local configurations
   */
  development: {
    explorer: 'https://rinkeby.etherscan.io/',
    KAT: {
      ADDRESS: '0x9dddff7752e1714c99edf940ae834f0d57d68546',
      DECIMALS: 18,
    },
    KYTE: {
      ADDRESS: '0x0dcfcf11e4c2eb233f73a79132e0a864ab219ed4',
      DECIMALS: 18,
    },
    NETWORK: 4,
    REDEEMER: {
      KAT_ADDRESS: '0xaf2c0f86a2d11816d04ad847ce0aebc98ca0424f',
      KYTE_ADDRESS: '0xc9e17c77a40a040287adbca4ca4f3e13acd8f650',
    },
    VOTE: {
      STAKE_ADDRESS: '0x76d8B624eFDDd1e9fC4297F82a2689315ac62d82',
      REVOKABLE_VOTE_CID: '0x0000000000000000000000000000000000000000000000000000000000000000',
    },
    RETAILER: {
      ADDRESS: '0x5a926B235e992d6BA52d98415E66aFe5078A1690',
    },
  },

  /**
   * Staging configurations
   */
  staging: {
    explorer: 'https://rinkeby.etherscan.io/',
    KAT: {
      ADDRESS: '0x9dddff7752e1714c99edf940ae834f0d57d68546',
      DECIMALS: 18,
    },
    KYTE: {
      ADDRESS: '0x0dcfcf11e4c2eb233f73a79132e0a864ab219ed4',
      DECIMALS: 18,
    },
    NETWORK: 4,
    REDEEMER: {
      KAT_ADDRESS: '0xaf2c0f86a2d11816d04ad847ce0aebc98ca0424f',
      KYTE_ADDRESS: '0xc9e17c77a40a040287adbca4ca4f3e13acd8f650',
    },
    VOTE: {
      STAKE_ADDRESS: '0x76d8B624eFDDd1e9fC4297F82a2689315ac62d82',
      REVOKABLE_VOTE_CID: '0x0000000000000000000000000000000000000000000000000000000000000000',
    },
    RETAILER: {
      ADDRESS: '0x5a926B235e992d6BA52d98415E66aFe5078A1690',
    },
  },

  /**
   * Production configurations
   */
  production: {
    explorer: 'https://etherscan.io/',
    KAT: {
      ADDRESS: '0x14da230d6726c50f759bc1838717f8ce6373509c',
      DECIMALS: 18,
    },
    KYTE: {
      ADDRESS: '0xa053c1b7013e77fe0a873ce0ca2bd5d0b7414c41',
      DECIMALS: 18,
    },
    NETWORK: 1,
    REDEEMER: {
      KAT_ADDRESS: '0x669f82C560049a756e56B9BB67931cf398ec30AF',
      KYTE_ADDRESS: '0x1C25Bbd12c7621876Ae6e03EB7bA03D019757B0a',
    },
    VOTE: {
      STAKE_ADDRESS: '0xc1d8c0cf8535784dfd96ad3bed38028d16f7f7ac',
      REVOKABLE_VOTE_CID: '0x0000000000000000000000000000000000000000000000000000000000000000',
    },
    RETAILER: {
      ADDRESS: '0x32629dd5c317494De8e777bF54Fb5a4BB585F5F1',
    },
  },
};

export default config;
